import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { StackProvider } from '@micromag/element-stack';
export { Spacer } from '@micromag/element-stack';

var styles = {"container":"micromag-element-layout-container","fullscreen":"micromag-element-layout-fullscreen"};

var propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  horizontalAlign: PropTypes.oneOf(['left', 'center', 'right']),
  verticalAlign: PropTypes.oneOf(['top', 'middle', 'bottom']),
  distribution: PropTypes.oneOf(['between', 'around', null]),
  fullscreen: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  style: PropTypes.object // eslint-disable-line
};
var defaultProps = {
  width: null,
  height: null,
  horizontalAlign: 'left',
  verticalAlign: 'top',
  distribution: null,
  fullscreen: false,
  className: null,
  children: null,
  style: null
};
var Layout = function Layout(_ref) {
  var width = _ref.width,
    height = _ref.height,
    horizontalAlign = _ref.horizontalAlign,
    verticalAlign = _ref.verticalAlign,
    distribution = _ref.distribution,
    fullscreen = _ref.fullscreen,
    className = _ref.className,
    children = _ref.children,
    style = _ref.style;
  var justifyContent = null;
  if (distribution !== null) {
    justifyContent = "space-".concat(distribution);
  } else if (verticalAlign === 'middle') {
    justifyContent = 'center';
  } else if (verticalAlign === 'bottom') {
    justifyContent = 'flex-end';
  }
  var alignItems = null;
  if (horizontalAlign === 'center') {
    alignItems = 'center';
  } else if (horizontalAlign === 'right') {
    alignItems = 'flex-end';
  }
  var finalStyle = _objectSpread({
    width: width,
    height: height,
    justifyContent: justifyContent,
    alignItems: alignItems
  }, style);
  return /*#__PURE__*/React.createElement(StackProvider, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty(_defineProperty({}, styles.fullscreen, fullscreen), className, className !== null)]),
    style: finalStyle
  }, children));
};
Layout.propTypes = propTypes;
Layout.defaultProps = defaultProps;

export { Layout as default };
